<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-4">Attached Files</h4>
      <div class="table-responsive">
        <table class="table table-nowrap table-centered table-hover mb-0 align-middle">
          <tbody>
          <tr>
            <td style="width: 45px;">
              <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
              </div>
            </td>
            <td>
              <h5 class="font-size-14 mb-1">
                <a href="javascript: void(0);" class="text-dark">Skote Landing.Zip</a>
              </h5>
              <small>Size : 3.25 MB</small>
            </td>
            <td>
              <div class="text-center">
                <a href="javascript: void(0);" class="text-dark">
                  <i class="bx bx-download h3 m-0"></i>
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
              </div>
            </td>
            <td>
              <h5 class="font-size-14 mb-1">
                <a href="javascript: void(0);" class="text-dark">Skote Admin.Zip</a>
              </h5>
              <small>Size : 3.15 MB</small>
            </td>
            <td>
              <div class="text-center">
                <a href="javascript: void(0);" class="text-dark">
                  <i class="bx bx-download h3 m-0"></i>
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
              </div>
            </td>
            <td>
              <h5 class="font-size-14 mb-1">
                <a href="javascript: void(0);" class="text-dark">Skote Logo.Zip</a>
              </h5>
              <small>Size : 2.02 MB</small>
            </td>
            <td>
              <div class="text-center">
                <a href="javascript: void(0);" class="text-dark">
                  <i class="bx bx-download h3 m-0"></i>
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
              </div>
            </td>
            <td>
              <h5 class="font-size-14">
                <a href="javascript: void(0);" class="text-dark">Veltrix admin.Zip</a>
              </h5>
              <small>Size : 2.25 MB</small>
            </td>
            <td>
              <div class="text-center">
                <a href="javascript: void(0);" class="text-dark">
                  <i class="bx bx-download h3 m-0"></i>
                </a>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilesCard"
}
</script>

<style scoped>

</style>
